var map = {
	"./audio/bankoslowka/do_slowniczka/BNP_Samodzielniak_6_B_1.mp3": "da3f",
	"./audio/bankoslowka/do_slowniczka/BNP_Samodzielniak_6_B_2.mp3": "4de7",
	"./audio/bankoslowka/do_slowniczka/backToTheGame.mp3": "649c",
	"./audio/bankoslowka/gratulacje/BNP_Samodzielniak_10_A.mp3": "d356",
	"./audio/bankoslowka/gratulacje/BNP_Samodzielniak_10_B.mp3": "fff3",
	"./audio/bankoslowka/gratulacje/BNP_Samodzielniak_10_C_1.mp3": "d142",
	"./audio/bankoslowka/gratulacje/BNP_Samodzielniak_10_C_2.mp3": "5a65",
	"./audio/bankoslowka/gratulacje/BNP_Samodzielniak_10_C_3.mp3": "e4a3",
	"./audio/bankoslowka/gratulacje/BNP_Samodzielniak_10_D_1.mp3": "9156",
	"./audio/bankoslowka/gratulacje/BNP_Samodzielniak_10_D_2.mp3": "1576",
	"./audio/bankoslowka/gratulacje/BNP_Samodzielniak_10_D_3.mp3": "bc33",
	"./audio/bankoslowka/karty/BANK.mp3": "5945",
	"./audio/bankoslowka/karty/BANKIER.mp3": "d28b",
	"./audio/bankoslowka/karty/BANKOMAT.mp3": "d7ec",
	"./audio/bankoslowka/karty/BUDZET_2.mp3": "4397",
	"./audio/bankoslowka/karty/GOTOWKA.mp3": "01bb",
	"./audio/bankoslowka/karty/HOLOGRAM.mp3": "d425",
	"./audio/bankoslowka/karty/INWESTYCJA.mp3": "eccc",
	"./audio/bankoslowka/karty/KARTA_PLATNICZA.mp3": "2288",
	"./audio/bankoslowka/karty/KIESZONKOWE_2.mp3": "938b",
	"./audio/bankoslowka/karty/KONTO.mp3": "b40a",
	"./audio/bankoslowka/karty/KONTO_BANKOWE.mp3": "c0e4",
	"./audio/bankoslowka/karty/LIMIT_1.mp3": "8e5d",
	"./audio/bankoslowka/karty/MENNICA.mp3": "044a",
	"./audio/bankoslowka/karty/NUMER_PIN.mp3": "d4c4",
	"./audio/bankoslowka/karty/OSZCZEDNOSCI.mp3": "d89f",
	"./audio/bankoslowka/karty/PIENIADZ.mp3": "9a45",
	"./audio/bankoslowka/karty/PLATNOSCI_ZBLIZENIOWE.mp3": "7e77",
	"./audio/bankoslowka/karty/POZYCZKA.mp3": "7cd0",
	"./audio/bankoslowka/karty/PREMIA.mp3": "f5b7",
	"./audio/bankoslowka/karty/PRZELEW_INTERNETOWY.mp3": "12be",
	"./audio/bankoslowka/karty/SALDO.mp3": "a6e4",
	"./audio/bankoslowka/karty/TERMINAL_PLATNICZY.mp3": "be2a",
	"./audio/bankoslowka/karty/TRANSAKCJA_2.mp3": "2028",
	"./audio/bankoslowka/karty/WALUTA.mp3": "6a00",
	"./audio/bankoslowka/karty/poziom-trudny/BNP_Samodzielniak_Bankoslowka_APLIKACJA_BANKOWA.mp3": "2875",
	"./audio/bankoslowka/karty/poziom-trudny/BNP_Samodzielniak_Bankoslowka_KARTA_KREDYTOWA.mp3": "5a3f",
	"./audio/bankoslowka/karty/poziom-trudny/BNP_Samodzielniak_Bankoslowka_NR_KONTA.mp3": "9e6a",
	"./audio/bankoslowka/karty/poziom-trudny/BNP_Samodzielniak_Bankoslowka_POZYCZKA.mp3": "d74b",
	"./audio/bankoslowka/karty/poziom-trudny/BNP_Samodzielniak_Bankoslowka_PRZELEW_NA_TEL.mp3": "30dc",
	"./audio/bankoslowka/karty/poziom-trudny/BNP_Samodzielniak_Bankoslowka_SALDO_2.mp3": "9393",
	"./audio/bankoslowka/karty/poziom-trudny/BNP_Samodzielniak_Bankoslowka_WYCIAG_Z_KONTA.mp3": "5e97",
	"./audio/bankoslowka/karty/poziom-trudny/BNP_Samodzielniak_Bankoslowka_WYTWORNIA_PAPIEROW.mp3": "292a",
	"./audio/bankoslowka/koniec_gry/BNP_Samodzielniak_11_B-straciles-3-zycia.mp3": "1cd2",
	"./audio/bankoslowka/koniec_gry/end_1.mp3": "3606",
	"./audio/bankoslowka/koniec_gry/end_2.mp3": "b80e",
	"./audio/bankoslowka/koniec_gry/utrata.mp3": "6f5f",
	"./audio/bankoslowka/litery/A.mp3": "4df0",
	"./audio/bankoslowka/litery/B.mp3": "d56f",
	"./audio/bankoslowka/litery/C.mp3": "ea0f",
	"./audio/bankoslowka/litery/D.mp3": "6df0",
	"./audio/bankoslowka/litery/E.mp3": "128e",
	"./audio/bankoslowka/litery/F.mp3": "4047",
	"./audio/bankoslowka/litery/G.mp3": "1c19",
	"./audio/bankoslowka/litery/H.mp3": "61ec",
	"./audio/bankoslowka/litery/I.mp3": "3183",
	"./audio/bankoslowka/litery/J.mp3": "4427",
	"./audio/bankoslowka/litery/K.mp3": "7148",
	"./audio/bankoslowka/litery/L.mp3": "1afc",
	"./audio/bankoslowka/litery/M.mp3": "976d",
	"./audio/bankoslowka/litery/N.mp3": "4764",
	"./audio/bankoslowka/litery/O.mp3": "84be",
	"./audio/bankoslowka/litery/P.mp3": "b5f9",
	"./audio/bankoslowka/litery/R.mp3": "104d",
	"./audio/bankoslowka/litery/S.mp3": "dbe8",
	"./audio/bankoslowka/litery/T.mp3": "1549",
	"./audio/bankoslowka/litery/U.mp3": "b5f92",
	"./audio/bankoslowka/litery/W.mp3": "799c",
	"./audio/bankoslowka/litery/Y.mp3": "69cc",
	"./audio/bankoslowka/litery/Z.mp3": "c5c1",
	"./audio/bankoslowka/litery/Ó.mp3": "885a",
	"./audio/bankoslowka/litery/Ą.mp3": "7229",
	"./audio/bankoslowka/litery/Ć.mp3": "53e3",
	"./audio/bankoslowka/litery/Ę.mp3": "59b4",
	"./audio/bankoslowka/litery/Ł.mp3": "eb0a",
	"./audio/bankoslowka/litery/Ś.mp3": "29fc",
	"./audio/bankoslowka/litery/Ź.mp3": "9095",
	"./audio/bankoslowka/litery/Ż.mp3": "26fd",
	"./audio/bankoslowka/ogolne/BNP_Samodzielniak_3_A i B.mp3": "40e9",
	"./audio/bankoslowka/ogolne/BNP_Samodzielniak_3_B.mp3": "abdb",
	"./audio/bankoslowka/ogolne/OLDmission_name.mp3": "38f2",
	"./audio/bankoslowka/ogolne/click_start.mp3": "ed9c",
	"./audio/bankoslowka/ogolne/intro.mp3": "be3b",
	"./audio/bankoslowka/ogolne/intro2.mp3": "a3d2",
	"./audio/bankoslowka/ogolne/mission_name.mp3": "6d8c",
	"./audio/bankoslowka/ogolne/nastepne-slowo.mp3": "2fd5",
	"./audio/bankoslowka/ogolne/rules.mp3": "8fce",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_A_1.mp3": "085f",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_A_2.mp3": "804c",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_A_3.mp3": "6a83",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_B_1.mp3": "0720",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_B_2.mp3": "b940",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_B_3.mp3": "27fe",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_C_1.mp3": "3233",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_C_2.mp3": "20db",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_C_3.mp3": "c5f8",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_D_1.mp3": "e621",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_D_2.mp3": "7383",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_D_3.mp3": "7a770",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_E_1.mp3": "fae4",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_E_2.mp3": "5d08",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_E_3.mp3": "9591",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_F_1.mp3": "077e",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_F_2.mp3": "7dc3",
	"./audio/bankoslowka/slowko_zaliczone/BNP_Samodzielniak_8_F_3.mp3": "22ac",
	"./audio/famfary/famfary.mp3": "b243",
	"./audio/game_level/latwy_hover.mp3": "33bd",
	"./audio/game_level/latwy_select.mp3": "ec3c",
	"./audio/game_level/trudny_hover.mp3": "ff4d",
	"./audio/game_level/trudny_select.mp3": "48ec",
	"./audio/intro/click_rules.mp3": "c630",
	"./audio/intro/click_start.mp3": "2a02",
	"./audio/intro/gameOn.mp3": "46fb",
	"./audio/intro/intro_benek.mp3": "9ffe",
	"./audio/intro/intro_benia.mp3": "d281",
	"./audio/intro/select_game_level.mp3": "240f",
	"./audio/intro/wymagane_pole.mp3": "21ad",
	"./audio/memory/card/error/BNP_Samodzielniak_17_L_1.mp3": "720b",
	"./audio/memory/card/error/BNP_Samodzielniak_17_L_2.mp3": "158b",
	"./audio/memory/card/sucess/BNP_Samodzielniak_16_D_1.mp3": "5479",
	"./audio/memory/card/sucess/BNP_Samodzielniak_16_E_1.mp3": "be9d",
	"./audio/memory/card/sucess/BNP_Samodzielniak_16_F_1.mp3": "bb14",
	"./audio/memory/card/sucess/BNP_Samodzielniak_16_G_1.mp3": "14fd",
	"./audio/memory/card/sucess/BNP_Samodzielniak_16_H_1.mp3": "5149",
	"./audio/memory/card/sucess/BNP_Samodzielniak_16_I_1.mp3": "1bbe",
	"./audio/memory/card/sucess/BNP_Samodzielniak_16_J_1.mp3": "c98d",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_A_1.mp3": "ff3e",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_A_2.mp3": "7fc4",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_B_1.mp3": "0e32",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_B_2.mp3": "5a72",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_C_1.mp3": "318c",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_C_2.mp3": "b8ff",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_D_2.mp3": "f0b2",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_E_2.mp3": "e567",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_F_2.mp3": "f833",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_G_2.mp3": "bc57",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_H_2.mp3": "202f",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_I_2.mp3": "5607",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_J_2.mp3": "f9f1",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_K_1.mp3": "5ed1",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_K_2.mp3": "2afc",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_M_1.mp3": "e6c8",
	"./audio/memory/card/sucess/BNP_Samodzielniak_17_M_2.mp3": "729a",
	"./audio/memory/ogolne/memory_rules.mp3": "6bfc",
	"./audio/memory/ogolne/misja_zaliczona/BNP_Samodzielniak_18_A.mp3": "b3bf",
	"./audio/memory/ogolne/misja_zaliczona/BNP_Samodzielniak_18_B.mp3": "e561",
	"./audio/memory/ogolne/misja_zaliczona/BNP_Samodzielniak_18_C.mp3": "8c74",
	"./audio/memory/ogolne/misja_zaliczona/BNP_Samodzielniak_18_D.mp3": "91a3",
	"./audio/memory/ogolne/misja_zaliczona/BNP_Samodzielniak_18_E.mp3": "bfc8",
	"./audio/memory/ogolne/misja_zaliczona/BNP_Samodzielniak_18_F.mp3": "c55b",
	"./audio/memory/ogolne/misja_zaliczona/BNP_Samodzielniak_18_G.mp3": "dff6",
	"./audio/memory/ogolne/mission_name.mp3": "ba1e",
	"./audio/ogolne/BNP_Samodzielniak_10_A.mp3": "f38b",
	"./audio/ogolne/BNP_Samodzielniak_10_B.mp3": "11ad",
	"./audio/ogolne/BNP_Samodzielniak_10_C_1.mp3": "bf3d",
	"./audio/ogolne/BNP_Samodzielniak_10_C_2.mp3": "e056",
	"./audio/ogolne/BNP_Samodzielniak_10_C_3.mp3": "9241",
	"./audio/ogolne/BNP_Samodzielniak_10_D_1.mp3": "b581",
	"./audio/ogolne/BNP_Samodzielniak_10_D_2.mp3": "d9c0",
	"./audio/ogolne/BNP_Samodzielniak_10_D_3.mp3": "4e42",
	"./audio/ogolne/BNP_Samodzielniak_11_A.mp3": "c515",
	"./audio/ogolne/BNP_Samodzielniak_11_B.mp3": "e3ae",
	"./audio/ogolne/BNP_Samodzielniak_11_C.mp3": "e1d1",
	"./audio/ogolne/BNP_Samodzielniak_11_D.mp3": "db3a",
	"./audio/ogolne/BNP_Samodzielniak_12_A.mp3": "5699",
	"./audio/ogolne/BNP_Samodzielniak_12_B.mp3": "c69d",
	"./audio/ogolne/BNP_Samodzielniak_13.mp3": "8784",
	"./audio/ogolne/BNP_Samodzielniak_14_A.mp3": "d59a",
	"./audio/ogolne/BNP_Samodzielniak_14_B.mp3": "f05a",
	"./audio/ogolne/BNP_Samodzielniak_15.mp3": "4a54",
	"./audio/ogolne/BNP_Samodzielniak_16_D_1.mp3": "035b",
	"./audio/ogolne/BNP_Samodzielniak_16_E_1.mp3": "e80d",
	"./audio/ogolne/BNP_Samodzielniak_16_F_1.mp3": "a933",
	"./audio/ogolne/BNP_Samodzielniak_16_G_1.mp3": "154b",
	"./audio/ogolne/BNP_Samodzielniak_16_H_1.mp3": "9231",
	"./audio/ogolne/BNP_Samodzielniak_16_I_1.mp3": "f421",
	"./audio/ogolne/BNP_Samodzielniak_16_J_1.mp3": "08d3",
	"./audio/ogolne/BNP_Samodzielniak_17_A_1.mp3": "e0dd",
	"./audio/ogolne/BNP_Samodzielniak_17_A_2.mp3": "0486",
	"./audio/ogolne/BNP_Samodzielniak_17_B_1.mp3": "7688",
	"./audio/ogolne/BNP_Samodzielniak_17_B_2.mp3": "59cf",
	"./audio/ogolne/BNP_Samodzielniak_17_C_1.mp3": "8534",
	"./audio/ogolne/BNP_Samodzielniak_17_C_2.mp3": "44dc",
	"./audio/ogolne/BNP_Samodzielniak_17_D_2.mp3": "20db9",
	"./audio/ogolne/BNP_Samodzielniak_17_E_2.mp3": "594b",
	"./audio/ogolne/BNP_Samodzielniak_17_F_2.mp3": "7175",
	"./audio/ogolne/BNP_Samodzielniak_17_G_2.mp3": "7d16",
	"./audio/ogolne/BNP_Samodzielniak_17_H_2.mp3": "3a96",
	"./audio/ogolne/BNP_Samodzielniak_17_I_2.mp3": "fdd0",
	"./audio/ogolne/BNP_Samodzielniak_17_J_2.mp3": "f616",
	"./audio/ogolne/BNP_Samodzielniak_17_K_1.mp3": "12ec",
	"./audio/ogolne/BNP_Samodzielniak_17_K_2.mp3": "53ad",
	"./audio/ogolne/BNP_Samodzielniak_17_L_1.mp3": "435a",
	"./audio/ogolne/BNP_Samodzielniak_17_L_2.mp3": "d4f6",
	"./audio/ogolne/BNP_Samodzielniak_17_M_1.mp3": "cd22",
	"./audio/ogolne/BNP_Samodzielniak_17_M_2.mp3": "8b1d",
	"./audio/ogolne/BNP_Samodzielniak_18_A.mp3": "3096",
	"./audio/ogolne/BNP_Samodzielniak_18_B.mp3": "f24b",
	"./audio/ogolne/BNP_Samodzielniak_18_C.mp3": "91a8",
	"./audio/ogolne/BNP_Samodzielniak_18_D.mp3": "a2f6",
	"./audio/ogolne/BNP_Samodzielniak_18_E.mp3": "33f0",
	"./audio/ogolne/BNP_Samodzielniak_18_F.mp3": "f195",
	"./audio/ogolne/BNP_Samodzielniak_18_G.mp3": "4100",
	"./audio/ogolne/BNP_Samodzielniak_19_A_1.mp3": "8fec",
	"./audio/ogolne/BNP_Samodzielniak_19_A_2.mp3": "db6c",
	"./audio/ogolne/BNP_Samodzielniak_19_B_1.mp3": "bb8e",
	"./audio/ogolne/BNP_Samodzielniak_19_B_2.mp3": "7d27",
	"./audio/ogolne/BNP_Samodzielniak_19_C_1.mp3": "2456",
	"./audio/ogolne/BNP_Samodzielniak_19_C_2.mp3": "82ef",
	"./audio/ogolne/BNP_Samodzielniak_1_A.mp3": "e5fc",
	"./audio/ogolne/BNP_Samodzielniak_1_B.mp3": "d894",
	"./audio/ogolne/BNP_Samodzielniak_1_C.mp3": "6937",
	"./audio/ogolne/BNP_Samodzielniak_1_D.mp3": "82d9",
	"./audio/ogolne/BNP_Samodzielniak_1_E.mp3": "50a6",
	"./audio/ogolne/BNP_Samodzielniak_1_F.mp3": "af00",
	"./audio/ogolne/BNP_Samodzielniak_1_G.mp3": "dc11",
	"./audio/ogolne/BNP_Samodzielniak_20_A.mp3": "1677",
	"./audio/ogolne/BNP_Samodzielniak_20_B.mp3": "3290",
	"./audio/ogolne/BNP_Samodzielniak_22_A.mp3": "21dc",
	"./audio/ogolne/BNP_Samodzielniak_22_B.mp3": "398c",
	"./audio/ogolne/BNP_Samodzielniak_23_A.mp3": "d000",
	"./audio/ogolne/BNP_Samodzielniak_23_B.mp3": "bc47",
	"./audio/ogolne/BNP_Samodzielniak_25_A.mp3": "412a",
	"./audio/ogolne/BNP_Samodzielniak_25_B.mp3": "2318",
	"./audio/ogolne/BNP_Samodzielniak_25_C.mp3": "51b9",
	"./audio/ogolne/BNP_Samodzielniak_25_D.mp3": "6dbe",
	"./audio/ogolne/BNP_Samodzielniak_25_E_1.mp3": "15d3",
	"./audio/ogolne/BNP_Samodzielniak_25_E_10.mp3": "29c2",
	"./audio/ogolne/BNP_Samodzielniak_25_E_11.mp3": "5f44",
	"./audio/ogolne/BNP_Samodzielniak_25_E_2.mp3": "d90c",
	"./audio/ogolne/BNP_Samodzielniak_25_E_3.mp3": "c535",
	"./audio/ogolne/BNP_Samodzielniak_25_E_4.mp3": "ac78",
	"./audio/ogolne/BNP_Samodzielniak_25_E_5.mp3": "aec1",
	"./audio/ogolne/BNP_Samodzielniak_25_E_6.mp3": "ba6d",
	"./audio/ogolne/BNP_Samodzielniak_25_E_7.mp3": "b7d6",
	"./audio/ogolne/BNP_Samodzielniak_25_E_8.mp3": "55d2",
	"./audio/ogolne/BNP_Samodzielniak_25_E_9.mp3": "3b6a",
	"./audio/ogolne/BNP_Samodzielniak_25_F.mp3": "2d11",
	"./audio/ogolne/BNP_Samodzielniak_26_A_1.mp3": "2843",
	"./audio/ogolne/BNP_Samodzielniak_26_A_2.mp3": "e56e",
	"./audio/ogolne/BNP_Samodzielniak_26_B_1.mp3": "9e17",
	"./audio/ogolne/BNP_Samodzielniak_26_B_2.mp3": "0a83",
	"./audio/ogolne/BNP_Samodzielniak_26_C_1.mp3": "dd5e",
	"./audio/ogolne/BNP_Samodzielniak_26_C_2.mp3": "ac1e",
	"./audio/ogolne/BNP_Samodzielniak_26_D_1.mp3": "9f09",
	"./audio/ogolne/BNP_Samodzielniak_26_D_2.mp3": "c0ac",
	"./audio/ogolne/BNP_Samodzielniak_26_E_1.mp3": "4441",
	"./audio/ogolne/BNP_Samodzielniak_26_E_2.mp3": "16ff",
	"./audio/ogolne/BNP_Samodzielniak_26_F_1.mp3": "31b4",
	"./audio/ogolne/BNP_Samodzielniak_26_F_2.mp3": "18ee",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_10_A.mp3": "ebf5",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_10_B.mp3": "a304",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_11_A.mp3": "b164",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_11_B.mp3": "16e7",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_1_A.mp3": "276a",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_1_B.mp3": "6089",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_2_A.mp3": "92ea",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_2_B.mp3": "212f",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_3_A.mp3": "f21f",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_3_B.mp3": "dc49",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_4_A.mp3": "eb8e",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_4_B.mp3": "4c56",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_5_A.mp3": "36cc",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_5_B.mp3": "9eec",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_6_A.mp3": "a260",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_6_B.mp3": "d622",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_7_A.mp3": "a2f2",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_7_B.mp3": "862c",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_8_A.mp3": "3f47",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_8_B.mp3": "2510",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_9_A.mp3": "4ff0",
	"./audio/ogolne/BNP_Samodzielniak_26_LICZEBNIKI_9_B.mp3": "176d",
	"./audio/ogolne/BNP_Samodzielniak_3_A.mp3": "5cf0",
	"./audio/ogolne/BNP_Samodzielniak_3_B.mp3": "91ec",
	"./audio/ogolne/BNP_Samodzielniak_3_C.mp3": "32ca",
	"./audio/ogolne/BNP_Samodzielniak_4_A.mp3": "c8ac",
	"./audio/ogolne/BNP_Samodzielniak_4_B.mp3": "faa1",
	"./audio/ogolne/BNP_Samodzielniak_5_A.mp3": "1f3f",
	"./audio/ogolne/BNP_Samodzielniak_5_B_1.mp3": "35a2",
	"./audio/ogolne/BNP_Samodzielniak_5_B_2.mp3": "9fbd",
	"./audio/ogolne/BNP_Samodzielniak_5_C_1.mp3": "a269",
	"./audio/ogolne/BNP_Samodzielniak_5_C_2.mp3": "e0d0",
	"./audio/ogolne/BNP_Samodzielniak_6_A_1.mp3": "99e2",
	"./audio/ogolne/BNP_Samodzielniak_6_A_10.mp3": "ec55",
	"./audio/ogolne/BNP_Samodzielniak_6_A_11.mp3": "d65e",
	"./audio/ogolne/BNP_Samodzielniak_6_A_12.mp3": "a3a2",
	"./audio/ogolne/BNP_Samodzielniak_6_A_13.mp3": "4d65",
	"./audio/ogolne/BNP_Samodzielniak_6_A_14.mp3": "0073",
	"./audio/ogolne/BNP_Samodzielniak_6_A_15.mp3": "7ab2",
	"./audio/ogolne/BNP_Samodzielniak_6_A_16.mp3": "c5d8",
	"./audio/ogolne/BNP_Samodzielniak_6_A_17.mp3": "dc8d",
	"./audio/ogolne/BNP_Samodzielniak_6_A_18.mp3": "b9d7",
	"./audio/ogolne/BNP_Samodzielniak_6_A_19.mp3": "b27a",
	"./audio/ogolne/BNP_Samodzielniak_6_A_2.mp3": "af79",
	"./audio/ogolne/BNP_Samodzielniak_6_A_20.mp3": "8d9f",
	"./audio/ogolne/BNP_Samodzielniak_6_A_21.mp3": "4bed",
	"./audio/ogolne/BNP_Samodzielniak_6_A_22.mp3": "02cd",
	"./audio/ogolne/BNP_Samodzielniak_6_A_23.mp3": "1590",
	"./audio/ogolne/BNP_Samodzielniak_6_A_24.mp3": "1767",
	"./audio/ogolne/BNP_Samodzielniak_6_A_25.mp3": "9602",
	"./audio/ogolne/BNP_Samodzielniak_6_A_26.mp3": "9b77",
	"./audio/ogolne/BNP_Samodzielniak_6_A_27.mp3": "26dd",
	"./audio/ogolne/BNP_Samodzielniak_6_A_28.mp3": "a0c2",
	"./audio/ogolne/BNP_Samodzielniak_6_A_3.mp3": "25ff",
	"./audio/ogolne/BNP_Samodzielniak_6_A_4.mp3": "88c1",
	"./audio/ogolne/BNP_Samodzielniak_6_A_5.mp3": "59e9",
	"./audio/ogolne/BNP_Samodzielniak_6_A_6.mp3": "f166",
	"./audio/ogolne/BNP_Samodzielniak_6_A_7.mp3": "c635",
	"./audio/ogolne/BNP_Samodzielniak_6_A_8.mp3": "696f",
	"./audio/ogolne/BNP_Samodzielniak_6_A_9.mp3": "36ec",
	"./audio/ogolne/BNP_Samodzielniak_6_B_1.mp3": "972e",
	"./audio/ogolne/BNP_Samodzielniak_6_B_2.mp3": "b270",
	"./audio/ogolne/BNP_Samodzielniak_7.mp3": "779b",
	"./audio/ogolne/BNP_Samodzielniak_8_A_1.mp3": "4f62",
	"./audio/ogolne/BNP_Samodzielniak_8_A_2.mp3": "7818",
	"./audio/ogolne/BNP_Samodzielniak_8_A_3.mp3": "ed70",
	"./audio/ogolne/BNP_Samodzielniak_8_B_1.mp3": "81a1",
	"./audio/ogolne/BNP_Samodzielniak_8_B_2.mp3": "a451",
	"./audio/ogolne/BNP_Samodzielniak_8_B_3.mp3": "09ca",
	"./audio/ogolne/BNP_Samodzielniak_8_C_1.mp3": "e990",
	"./audio/ogolne/BNP_Samodzielniak_8_C_2.mp3": "670d",
	"./audio/ogolne/BNP_Samodzielniak_8_C_3.mp3": "64b6",
	"./audio/ogolne/BNP_Samodzielniak_8_D_1.mp3": "e7ec",
	"./audio/ogolne/BNP_Samodzielniak_8_D_2.mp3": "c9c8",
	"./audio/ogolne/BNP_Samodzielniak_8_D_3.mp3": "6325",
	"./audio/ogolne/BNP_Samodzielniak_8_E_1.mp3": "adfc",
	"./audio/ogolne/BNP_Samodzielniak_8_E_2.mp3": "b5eb",
	"./audio/ogolne/BNP_Samodzielniak_8_E_3.mp3": "0e6d",
	"./audio/ogolne/BNP_Samodzielniak_8_F_1.mp3": "6618",
	"./audio/ogolne/BNP_Samodzielniak_8_F_2.mp3": "5a4f",
	"./audio/ogolne/BNP_Samodzielniak_8_F_3.mp3": "0e1f",
	"./audio/ogolne/BNP_Samodzielniak_9.mp3": "30c9",
	"./audio/shop/end_game/_udalo_sie.mp3": "5aec",
	"./audio/shop/end_game/nie-skompletowales.mp3": "e83f",
	"./audio/shop/end_game/przekroczony_budzet.mp3": "2840",
	"./audio/shop/end_game/udalo_sie.mp3": "9905",
	"./audio/shop/end_game/zakupy_zero.mp3": "4153",
	"./audio/shop/money/10zl.mp3": "e3a4",
	"./audio/shop/money/11zl.mp3": "af57",
	"./audio/shop/money/12zl.mp3": "7047",
	"./audio/shop/money/13zl.mp3": "a443",
	"./audio/shop/money/14zl.mp3": "8c3f",
	"./audio/shop/money/15zl.mp3": "533d",
	"./audio/shop/money/1zl.mp3": "51e3",
	"./audio/shop/money/2zl.mp3": "e046",
	"./audio/shop/money/3zl.mp3": "148b",
	"./audio/shop/money/4zl.mp3": "fa7f",
	"./audio/shop/money/5zl.mp3": "c5320",
	"./audio/shop/money/6zl.mp3": "4454",
	"./audio/shop/money/7zl.mp3": "4f11",
	"./audio/shop/money/8zl.mp3": "afa0",
	"./audio/shop/money/9zl.mp3": "be72",
	"./audio/shop/money/inne/10zl.mp3": "52de",
	"./audio/shop/money/inne/12zl.mp3": "5348",
	"./audio/shop/money/inne/14zl.mp3": "b1be",
	"./audio/shop/money/inne/16zl.mp3": "775d",
	"./audio/shop/money/inne/18zl.mp3": "189f",
	"./audio/shop/money/inne/20zl.mp3": "e16f",
	"./audio/shop/money/inne/22zl.mp3": "ae26",
	"./audio/shop/money/inne/24zl.mp3": "9d4f",
	"./audio/shop/money/inne/26zl.mp3": "1746",
	"./audio/shop/money/inne/28zl.mp3": "9f04",
	"./audio/shop/money/inne/30zl.mp3": "e7ff",
	"./audio/shop/money/inne/40zl.mp3": "5dd8",
	"./audio/shop/money/inne/4zl.mp3": "286a",
	"./audio/shop/money/inne/6zl.mp3": "5664",
	"./audio/shop/money/inne/8zl.mp3": "bd18",
	"./audio/shop/money/number/1.mp3": "60b1",
	"./audio/shop/money/number/10.mp3": "c1b2",
	"./audio/shop/money/number/11.mp3": "dcb6",
	"./audio/shop/money/number/12.mp3": "81a1c",
	"./audio/shop/money/number/13.mp3": "d555",
	"./audio/shop/money/number/14.mp3": "f5b8",
	"./audio/shop/money/number/15.mp3": "86ec",
	"./audio/shop/money/number/2.mp3": "f1ce",
	"./audio/shop/money/number/20.mp3": "96d1",
	"./audio/shop/money/number/3.mp3": "44f2",
	"./audio/shop/money/number/4.mp3": "213d",
	"./audio/shop/money/number/5.mp3": "f982",
	"./audio/shop/money/number/6.mp3": "4c14",
	"./audio/shop/money/number/7.mp3": "a87b",
	"./audio/shop/money/number/8.mp3": "e72d",
	"./audio/shop/money/number/9.mp3": "18bd",
	"./audio/shop/ogolne/benia_budzet.mp3": "1557",
	"./audio/shop/ogolne/end_game1.mp3": "1dfc",
	"./audio/shop/ogolne/kaczka_end_1.mp3": "1a48",
	"./audio/shop/ogolne/kaczka_end_2.mp3": "8bb0",
	"./audio/shop/ogolne/kaczka_kupuj.mp3": "8c14",
	"./audio/shop/ogolne/lista_zakupow.mp3": "a674",
	"./audio/shop/ogolne/masz_20_zl.mp3": "105a",
	"./audio/shop/ogolne/mision_name.mp3": "9b30",
	"./audio/shop/ogolne/przekroczyles_budzet.mp3": "887d",
	"./audio/shop/ogolne/shop_rules.mp3": "eb14",
	"./audio/shop/reszta/01-reszta-z-twoich-zakupow.mp3": "e6c9",
	"./audio/shop/reszta/02-reszta-z-twoich-zakupow.mp3": "5448",
	"./audio/shop/reszta/03-reszta-z-twoich-zakupow.mp3": "119a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b7b";